var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideoPlayer(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.6667 6H7.33333C6.59695 6 6 6.59695 6 7.33333V24.6667C6 25.403 6.59695 26 7.33333 26H24.6667C25.403 26 26 25.403 26 24.6667V7.33333C26 6.59695 25.403 6 24.6667 6Z",
    stroke: "#257FFC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4339 19.2533C14.3179 19.3112 14.1891 19.3384 14.0596 19.3325C13.9301 19.3266 13.8043 19.2877 13.694 19.2195C13.5838 19.1513 13.4928 19.056 13.4297 18.9428C13.3666 18.8296 13.3335 18.7021 13.3335 18.5724V13.4276C13.3335 13.2979 13.3666 13.1705 13.4297 13.0572C13.4928 12.944 13.5838 12.8487 13.694 12.7805C13.8043 12.7123 13.9301 12.6734 14.0596 12.6675C14.1891 12.6616 14.3179 12.6888 14.4339 12.7467L19.5797 15.32C19.7061 15.3831 19.8124 15.4801 19.8867 15.6002C19.961 15.7203 20.0003 15.8588 20.0003 16C20.0003 16.1412 19.961 16.2797 19.8867 16.3998C19.8124 16.5199 19.7061 16.6169 19.5797 16.68L14.4339 19.2533Z",
    stroke: "#257FFC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 9.33333H26",
    stroke: "#257FFC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6 22.6667H26",
    stroke: "#257FFC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoPlayer);
export default __webpack_public_path__ + "static/media/video-player.94648a3e.svg";
export { ForwardRef as ReactComponent };